import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import logo from '../assest/ecomlogo.png'; // AHA MART logo

const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(SummaryApi.verifyAdmin.url, {
        method: SummaryApi.verifyAdmin.method,
        headers: {
          'Authorization': 'Bearer oakyaecom_no_units_916',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: data.username,
          password: data.password,
        }),
      });

      const responseData = await response.json();

      if (response.ok && responseData?.status && responseData?.adminid) {
        sessionStorage.setItem('admin_id_encoded', btoa(responseData.adminid));
        
        toast.success(responseData.message || 'Login successful');
        navigate('/admin-panel/dashboard', { replace: true });
      } else {
        toast.error(responseData.message || 'Invalid username or password');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden border border-[#f36c32]/20">
        {/* Header */}
        <div 
          className="py-10 flex flex-col items-center"
          style={{ backgroundColor: '#f36c32' }}
        >
          {/* Larger logo circle */}
          <div className="w-36 h-36 rounded-full overflow-hidden border-4 border-white shadow-2xl bg-white p-2">
            <img
              src={logo}
              alt="AHA MART Logo"
              className="w-full h-full object-cover rounded-full"
            />
          </div>

          {/* Brand name below logo */}
          <h1 className="mt-6 text-white text-4xl font-extrabold tracking-wider">
            AHA MART
          </h1>
          <p className="mt-1 text-white/90 text-lg font-medium">
            Admin Panel
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-8 flex flex-col gap-6">
          {/* Username */}
          <div className="flex flex-col gap-1.5">
            <label className="text-gray-800 font-medium">Username</label>
            <input
              type="text"
              name="username"
              placeholder="Enter username"
              value={data.username}
              onChange={handleOnChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f36c32]/50 focus:border-transparent transition"
              required
            />
          </div>

          {/* Password */}
          <div className="flex flex-col gap-1.5">
            <label className="text-gray-800 font-medium">Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Enter password"
                value={data.password}
                onChange={handleOnChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f36c32]/50 focus:border-transparent transition pr-12"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#f36c32] transition"
              >
                {showPassword ? <FaEyeSlash size={22} /> : <FaEye size={22} />}
              </button>
            </div>

            <Link
              to="/forgot-password"
              className="text-sm text-[#2e3192] hover:underline self-end mt-1 font-medium"
            >
              Forgot password?
            </Link>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`mt-6 text-white font-semibold py-3.5 px-8 rounded-lg transition transform hover:scale-[1.02] active:scale-100 flex items-center justify-center gap-3 shadow-md ${
              loading ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-lg hover:bg-orange-600'
            }`}
            style={{ backgroundColor: '#f36c32' }}
          >
            {loading ? (
              <>
                <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                <span>Verifying...</span>
              </>
            ) : (
              'Login to Dashboard'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;